import React from 'react';
import styles from './Spinner.module.css';

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'medium' }) => {
  const spinnerClass = `${styles.spinner} ${styles[size]}`;
  return <div className={spinnerClass}></div>;
};
